Vue.asyncComponent('cms-dashboard-profile', {
    computed: {
        /**
         * User.
         */
        user() {
            return this.$userInterfaceHandler.getUserInterface()?.user || {};
        },
        /**
         * Avatar.
         */
        avatar() {
            return this.$userInterfaceHandler.getUserInterface()?.avatar || '';
        },
        /**
         * First name.
         */
        firstName() {
            return this.user?.firstName || this.user?.name || this.user?.email || this.$t('gebruiker');
        },
    },
    methods: {
        /**
         * Redirect to profile.
         */
        redirectToProfile() {
            if (! this.user?.id) {
                return;
            }

            this.$router.push({
                name: 'form',
                params: {
                    bundle: 'cms-user',
                    gridDefinition: 'grid',
                    definition: 'profile',
                    objectId: this.user.id,
                },
            });
        },
        /**
         * Redirect to change password.
         */
        redirectToChangePassword() {
            if (! this.user?.id) {
                return;
            }

            this.$router.push({
                name: 'form',
                params: {
                    bundle: 'cms-user',
                    gridDefinition: 'grid',
                    definition: 'change-password',
                    objectId: this.user.id,
                },
            });
        },
    },
}, 'cms/dashboard/live/cms-dashboard-profile.html');
